import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'

import ProvidersAndRoutesWithAuth from '../../ProvidersAndRoutesWithAuth'

import { MAX_SCREEN_SIZE } from '../Constants/WebAppMobileScreenConstants'
import WebAppMobileScreen from '../WebAppMobileScreen/WebAppMobileScreen'

const WebAppCompatibleView = (): React.ReactElement => {
   const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth)

   const onWindowWidthResize = () => {
      setWindowWidth(window.innerWidth)
   }

   useEffect(() => {
      window.addEventListener('resize', onWindowWidthResize)

      return () => {
         window.removeEventListener('resize', onWindowWidthResize)
      }
   }, [])

   const isCurrentScreenResolutionCompatible = windowWidth < MAX_SCREEN_SIZE

   return isCurrentScreenResolutionCompatible ? (
      <WebAppMobileScreen />
   ) : (
      <ProvidersAndRoutesWithAuth />
   )
}

export default observer(WebAppCompatibleView)
